<template>
  <NuxtLink
    v-if="notice.title && notice.menu_url"
    :to="localePath(notice.menu_url)"
    class="group flex flex-col gap-5 border-b border-gray py-3.75 first:border-t"
  >
    <TypeBadge
      v-if="notice.announcementTags?.length || (notice as any).type"
      :text="
        notice.announcementTags?.map((t) => t.name).join(', ') ||
        (notice as any).type
      "
      class="transform-colors max-w-36 duration-100 ease-out group-hover:border-[#595959] group-hover:bg-[#595959] group-hover:text-white"
    />

    <h3
      class="transform-colors w-72.5 text-[17px] leading-[124%] duration-100 ease-out group-hover:text-[#595959] md:w-85 md:text-xl/[120%] xl:w-108.75! xl:text-[26px]! xl:leading-[122%]! 2xl:w-126.75! 2xl:text-3xl!"
    >
      {{ notice.title }}
    </h3>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { Notice } from '~/types'

interface Props {
  notice: Notice
}

const props = defineProps<Props>()

const localePath = useLocalePath()
</script>
